// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","otherApps":"otherApps-1z9MR","apps":"apps-2v64S","app":"app-2PGrA","logo":"logo-wogva","splash":"splash-2jTsx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/other-apps/_otherApps.css
// module id = 1173
// module chunks = 1